module.exports = __webpack_public_path__ + "img/car.2b8c25b9.svg";